// Announcement Bar Slider Component
if (!customElements.get('custom-announcement-bar')) {
  class CustomAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.delay = 5000;
      this.items = null;
      this.currentIndex = 0;
      this.intervalID = null;
    }

    connectedCallback() {
      // Get delay from data attribute
      this.delay = Number(this.dataset.delay) * 1000 || 5000;
      
      // Get all announcement items
      this.items = this.querySelectorAll('.notification-bar-js');
      
      // Set container height to match tallest announcement
      this.setContainerHeight();
      
      // Only initialize if there are multiple items
      if (this.items.length > 1) {
        this.init();
      }
    }

    setContainerHeight() {
      if (this.items.length === 0) return;
      
      let maxHeight = 0;
      
      // Temporarily measure each item's natural height
      this.items.forEach(item => {
        // Save original styles
        const originalPosition = item.style.position;
        const originalTop = item.style.top;
        const originalVisibility = item.style.visibility;
        const originalZIndex = item.style.zIndex;
        
        // Temporarily position item to measure its natural height
        item.style.position = 'static';
        item.style.top = 'auto';
        item.style.visibility = 'visible';
        item.style.zIndex = 'auto';
        
        // Force a reflow to ensure accurate measurement
        void item.offsetHeight;
        
        const height = item.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
        
        // Restore original styles
        item.style.position = originalPosition;
        item.style.top = originalTop;
        item.style.visibility = originalVisibility;
        item.style.zIndex = originalZIndex;
      });
      
      // Set container height to the tallest item
      if (maxHeight > 0) {
        this.style.height = maxHeight + 'px';
      }
    }

    init() {
      // Pause on hover
      this.addEventListener('mouseenter', this.pause.bind(this));
      this.addEventListener('mouseleave', this.start.bind(this));
      
      // Start the slider
      this.start();
    }

    start() {
      if (this.items.length <= 1) return;
      
      this.stop(); // Clear any existing interval
      this.intervalID = setInterval(() => {
        this.next();
      }, this.delay);
    }

    pause() {
      this.stop();
    }

    stop() {
      if (this.intervalID) {
        clearInterval(this.intervalID);
        this.intervalID = null;
      }
    }

    next() {
      if (this.items.length <= 1) return;
      
      const currentItem = this.items[this.currentIndex];
      
      // Remove active classes from current item
      currentItem.classList.remove('active');
      currentItem.classList.remove('active-show');
      
      // Move to next item
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
      
      const nextItem = this.items[this.currentIndex];
      
      // Add active classes to next item
      nextItem.classList.add('active');
      setTimeout(() => {
        nextItem.classList.add('active-show');
      }, 50);
    }

    disconnectedCallback() {
      this.stop();
    }
  }

  customElements.define('custom-announcement-bar', CustomAnnouncementBar);
}


/**
 * EU legal-guarantee notice modal.
 * Self-contained so the snippet can be reused outside the product page.
 */
if (!customElements.get('legal-guarantee-notice')) {
  class LegalGuaranteeNotice extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
      this.onTriggerClick = this.onTriggerClick.bind(this);
      this.onModalClick = this.onModalClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
    }

    connectedCallback() {
      this.trigger = this.querySelector('[data-legal-guarantee-notice-open]');
      this.modal = this.querySelector('.legal-guarantee-notice__modal');
      if (!this.trigger || !this.modal) return;

      this.trigger.addEventListener('click', this.onTriggerClick);
      this.modal.addEventListener('click', this.onModalClick);
    }

    disconnectedCallback() {
      this.close();
      if (this.trigger) this.trigger.removeEventListener('click', this.onTriggerClick);
      if (this.modal) this.modal.removeEventListener('click', this.onModalClick);
    }

    onTriggerClick(event) {
      event.preventDefault();
      this.open();
    }

    onModalClick(event) {
      if (event.target.closest('[data-legal-guarantee-notice-close]')) {
        this.close();
      }
    }

    onKeyDown(event) {
      if (event.key === 'Escape') this.close();
    }

    open() {
      if (!this.modal || this.isOpen) return;

      this.modalParent = this.modal.parentNode;
      this.modalNext = this.modal.nextSibling;
      document.body.appendChild(this.modal);
      this.modal.classList.add('is-open');
      this.modal.removeAttribute('hidden');
      document.body.classList.add('legal-guarantee-notice-open');
      document.addEventListener('keydown', this.onKeyDown);
      this.isOpen = true;

      const closeButton = this.modal.querySelector('.legal-guarantee-notice__close');
      if (closeButton) closeButton.focus();
    }

    close() {
      if (!this.modal || !this.isOpen) return;

      this.modal.classList.remove('is-open');
      this.modal.setAttribute('hidden', '');
      document.body.classList.remove('legal-guarantee-notice-open');
      document.removeEventListener('keydown', this.onKeyDown);

      if (this.modalParent) {
        if (this.modalNext && this.modalNext.parentNode === this.modalParent) {
          this.modalParent.insertBefore(this.modal, this.modalNext);
        } else {
          this.modalParent.appendChild(this.modal);
        }
        this.modalParent = null;
        this.modalNext = null;
      }

      this.isOpen = false;
      if (this.trigger) this.trigger.focus();
    }
  }

  customElements.define('legal-guarantee-notice', LegalGuaranteeNotice);
}

